<template>
  <div class="live-program">
    <scroll :probeType="3" :pullUpLoad="true" class="scroll-content" ref="scrollRef">
      <div class="scroll-wrapper">
        <div class="program-item" v-for="(item, index) in radioStationList" :key="index">
          <img class="item-img" :src="item.pictureUrl" alt="" />
          <div class="center-content">
            <span class="content-title">{{ item.name }}</span>
            <div class="content-info">
              <div class="content-info-current text-line-1">正在直播：{{ item.programName }}</div>
              <div class="content-info-icon content-info-playing" v-if="item.isPlaying">
                <playing-icon />
              </div>
              <div class="content-info-icon" v-else>
                <i class="play-icon v-icon-play-small" />
              </div>
            </div>
            <div class="content-clicknum">
              <i class="nums-icon v-icon-listen-times" />
              <span>{{ item.clickSum }}</span>
            </div>
          </div>
        </div>
        <div class="end-tips">已经到底了~</div>
      </div>
    </scroll>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import Scroll from "@/components/Scroll/Scroll";
import PlayingIcon from "@/components/Base/PlayingIcon";
import { queryRadioStationAndProgram } from "@/http/api";

export default defineComponent({
  name: "LivingProgram",
  components: {
    Scroll,
    PlayingIcon
  },
  props: {
    radioStationCode: {
      type: String
    }
  },
  setup(props) {
    const scrollRef = ref(null);
    const radioStationList = ref([]);

    function fixNumToBig(val) {
      if (val > 10000) {
        return `${(val / 10000).toFixed(2)}万`;
      }
      return val;
    }

    const getRadioList = async () => {
      const result = await queryRadioStationAndProgram({
        categoryId: -1
      });
      radioStationList.value = result.data;
      getRadioStationCode();
      console.log(result);
    };

    const getRadioStationCode = () => {
      radioStationList.value.forEach(item => {
        item.clickSum = fixNumToBig(item.clickSum);
        if (item.code == props.radioStationCode) {
          item.isPlaying = true;
        } else {
          item.isPlaying = false;
        }
      });
    };

    onMounted(async () => {
      await getRadioList();
      scrollRef.value.scroll.refresh();
    });

    return {
      scrollRef,
      radioStationList
    };
  }
});
</script>

<style lang="scss" scoped>
.live-program {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  z-index: 9;
  overflow: hidden;

  .scroll-content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;
    padding: 0 17px;
  }

  .scroll-wrapper {
    width: 100%;
    min-height: calc(100% + 1px);
  }

  .program-item {
    display: flex;
    align-items: center;
    width: 100%;
    height: 95px;
    border-radius: 11px;
    border: 1px solid #e1e6e9;
    box-sizing: border-box;
    padding: 8px 12px;
    margin-top: 10px;

    &:last-child {
      margin-bottom: 20px;
    }

    .item-img {
      width: 80px;
      height: 80px;
      margin-right: 25px;
      border: 1px solid rgba(225, 230, 233, 0.7);
      box-sizing: border-box;
      border-radius: 4px;
    }

    .center-content {
      display: flex;
      flex: 1;
      width: 100%;
      flex-direction: column;
      height: 80px;
      justify-content: space-between;

      .content-title {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1a1b1c;
        line-height: 22px;
      }

      .content-info {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .content-info-current {
          display: flex;
          align-items: center;
          width: 140px;
          height: 24px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #7b7c7d;
          background: #f3f4f5;
          border-radius: 4px;
          box-sizing: border-box;
          padding-left: 3px;
        }

        .content-info-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          background: rgba(240, 244, 249, 0.8);
          color: #666;
          border-radius: 50%;
          overflow: hidden;

          .play-icon {
            transform: translateX(2px);
          }
        }

        .content-info-playing {
          background: transparent;
        }
      }

      .content-clicknum {
        display: flex;
        align-items: center;

        .nums-icon {
          color: #f76745;
        }

        & > span {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #7b7c7d;
          margin-left: 5px;
        }
      }
    }
  }

  .end-tips {
    padding: 15px 0;
    text-align: center;
    font-size: 14px;
    color: #999;
    letter-spacing: 1px;
    text-indent: 1px;
  }
}
</style>
